import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

import { ds } from '@/components/lib/design.system';

const SvgComponent = props => (
    <Svg width="20" height="20" viewBox="0 0 20 20" fill="none" {...props}>
        <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.83341 4.1665C5.83341 2.7858 6.95271 1.6665 8.33341 1.6665H15.8334C17.2142 1.6665 18.3334 2.7858 18.3334 4.1665V11.6665C18.3334 13.0473 17.2142 14.1665 15.8334 14.1665H14.1667V15.8332C14.1667 17.2139 13.0475 18.3332 11.6667 18.3332H4.16675C2.78604 18.3332 1.66675 17.2139 1.66675 15.8332V8.33317C1.66675 6.95246 2.78604 5.83317 4.16675 5.83317H5.83341V4.1665ZM7.50008 5.83317H11.6667C13.0475 5.83317 14.1667 6.95246 14.1667 8.33317V12.4998H15.8334C16.2937 12.4998 16.6667 12.1268 16.6667 11.6665V4.1665C16.6667 3.70627 16.2937 3.33317 15.8334 3.33317H8.33341C7.87318 3.33317 7.50008 3.70627 7.50008 4.1665V5.83317ZM4.16675 7.49984C3.70651 7.49984 3.33341 7.87294 3.33341 8.33317V15.8332C3.33341 16.2934 3.70651 16.6665 4.16675 16.6665H11.6667C12.127 16.6665 12.5001 16.2934 12.5001 15.8332V8.33317C12.5001 7.87294 12.127 7.49984 11.6667 7.49984H4.16675Z"
            fill={ds.colorValue.icon.brand}
        />
    </Svg>
);

export default SvgComponent;
